const defaultState = null

export const SET_TRADE_LAST_RESULT = 'SET_TRADE_LAST_RESULT';

export const tradeLastResultReducer = (state = defaultState, action: any) => {
    const { type, data } = action;
    if (type === SET_TRADE_LAST_RESULT) return data
    return state;
}